import { useEffect } from 'react';
import CampaignRankingCard from './components/campaign-ranking-card';
import SectionSummary from './components/section-summary';
import Totals from './components/totals';
import useDashboard, { DASHBOARD_SECTIONS } from './hooks/use-dashboard';

export const DashboardPage = () => {
  const {
    sections,
    totalUsersLoggedIn,
    totalViews,
    totalFavorites,
    totalComments,
    totalDownloads,
    activeCampaigns,
    campaignRankings,
    campaignTopPublications,
    fetchData,
  } = useDashboard();

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <div className="flex flex-col gap-6 p-4">
      <h1 className="text-2xl font-bold text-gray-800">Dashboard</h1>

      <Totals
        totalUsersLoggedIn={totalUsersLoggedIn}
        totalViews={totalViews}
        totalFavorites={totalFavorites}
        totalComments={totalComments}
        totalDownloads={totalDownloads}
      />

      <CampaignRankingCard
        campaigns={activeCampaigns}
        campaignRankings={campaignRankings}
        campaignTopPublications={campaignTopPublications}
      />

      <div className="flex flex-col gap-6">
        {DASHBOARD_SECTIONS.map(({ collection, label, path }) => (
          <div key={collection} className="bg-white rounded-xl p-5 shadow-sm border border-gray-100">
            <SectionSummary
              label={label}
              path={path}
              collection={collection}
              items={sections[collection] ?? []}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
